import React from "react";
import PropTypes from "prop-types";
import { cn } from "./helpers/utils";

const disabledColors = {
  bg: "bg-stone-300",
  text: "text-stone-300",
  border: "border-stone-300",
};

const colors = {
  blue: {
    bg: "bg-main-color",
    text: "text-main-color",
    border: "border-blue",
  },
  orange: {
    bg: "bg-[#F97E73]",
    text: "text-[#F97E73]",
    border: "border-[#F97E73]",
  },
  green: {
    bg: "bg-[#29AD63]",
    text: "text-[#29AD63]",
    border: "border-[#29AD63]",
  },
  red: {
    bg: "bg-[#DF4D4D]",
    text: "text-[#DF4D4D]",
    border: "border-[#DF4D4D]",
  },
  lightblue: {
    bg: "bg-lightblue",
    text: "text-main-color",
    border: "bg-lightblue",
  },
  disabled: {
    ...disabledColors,
  },
};

export default function Button({
  label,
  variant = "contained",
  color = "blue",
  icon,
  onClick,
  disabled,
  plusIcon,
  className,
  type = "button",
}) {
  const plusIconStyle = " h-10 w-10 rounded-full";
  const normalStyle = "px-4 py-3 rounded-md ";
  const styleClasses = [
    `font-semibold md:h-auto md:w-auto justify-center flex flex-row items-center md:gap-2 ${plusIcon ? plusIconStyle : normalStyle} `,
    className,
  ];
  const activeColor = disabled ? disabledColors : colors[color] ?? colors.blue;

  if (variant === "contained") {
    styleClasses.push(activeColor.bg);
    styleClasses.push("text-white");
  } else if (variant === "outlined") {
    styleClasses.push("border");
    styleClasses.push(activeColor.border);
    styleClasses.push(activeColor.text);
  } else if (variant === "noborder") {
    styleClasses.push(activeColor.border);
    styleClasses.push(activeColor.text);
  }

  return (
    <button
      className={cn(styleClasses)}
      onClick={onClick}
      disabled={disabled ?? false}
      type={type}
    >
      {icon}
      {label}
    </button>
  );
}
Button.propTypes = {
  label: PropTypes.any,
  variant: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.any,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  plusIcon: PropTypes.bool,
};
